/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['t', '../arrayMerge'], function(T, arrayMerge) {
    'use strict';
    return function(data) {
        var copyright;
        var json = data[0] || data;
        if (data.length > 1) {
            // this is edge of the world case
            json.regions = arrayMerge(data[0].regions, data[1].regions, function(first, second) {
                return first.country.ISO3 === second.country.ISO3;
            });
        }
        copyright = new T('<div id=\'copyrightMessage\'>' +
            '<h4>General Copyrights:</h4>' +
            '{{@generalCopyrights}}<p>{{=_val}}</p>{{/@generalCopyrights}}' +
            '{{@regions}}<h4>{{=_val.country.label}}:</h4>' +
            '{{_val.copyrightImages}}<img style=\'width: 200px;float:left;\' ' +
            'src=\'{{=_val.copyrightImages}}\'/>{{/_val.copyrightImages}}' +
            '{{@_val.copyrights}}<p>{{=_val}}</p>{{/@_val.copyrights}}{{/@regions}}' +
            '</div>');
        return copyright.render(json);
    };
});



// WEBPACK FOOTER //
// ./model/copyright/copyright.js